html,body{
 height: 100%;
  width:100%;
  margin: 0;
  padding: 0;
 position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  vertical-align: middle;
  -webkit-overflow-scrolling: touch;

}
/*body > #app > .white{
  background: #e7e7e9;
}*/

.dark{
  @import "../../app/app-theme";
}

.white{
  @import "../../app/app-light";
}

@import "../fonts/font-awesome-4.7.0/css/font-awesome.css";

@import "../../../node_modules/animatewithsass/animate.scss";

@font-face {
  font-family: "Solomon_Black";
  src: url("../fonts/Scanomat_Font/Solomon_Black_0.otf") format("opentype");
}

@font-face {
  font-family: "Solomon_Black_Deco";
  src: url("../fonts/Scanomat_Font/Solomon_Black_Deco_0.otf") format("opentype");
}

@font-face {
  font-family: "Solomon_Bold";
  src: url("../fonts/Scanomat_Font/Solomon_Bold.otf") format("opentype");
}

@font-face {
  font-family: "Solomon_Bold_Deco";
  src: url("../fonts/Scanomat_Font/Solomon_Bold_Deco.otf") format("opentype");
}

@font-face {
  font-family: "Solomon_Book";
  src: url("../fonts/Scanomat_Font/Solomon_Book.otf") format("opentype");
}

@font-face {
  font-family: "Solomon_Book_Deco";
  src: url("../fonts/Scanomat_Font/Solomon_Book_Deco.otf") format("opentype");
}

@font-face {
  font-family: "Solomon_Light";
  src: url("../fonts/Scanomat_Font/Solomon_Light.otf") format("opentype");
}

@font-face {
  font-family: "Solomon_Light_Deco";
  src: url("../fonts/Scanomat_Font/Solomon_Light_Deco.otf") format("opentype");
}

@font-face {
  font-family: "Solomon_Normal";
  src: url("../fonts/Scanomat_Font/Solomon_Normal.otf") format("opentype");
}

@font-face {
  font-family: "Solomon_Normal_Deco";
  src: url("../fonts/Scanomat_Font/Solomon_Normal_Deco.otf") format("opentype");
}

@font-face {
  font-family: "Solomon_Thin";
  src: url("../fonts/Scanomat_Font/Solomon_Thin.otf") format("opentype");
}

@font-face {
  font-family: "Solomon_Thin_Deco";
  src: url("../fonts/Scanomat_Font/Solomon_Thin_Deco.otf") format("opentype");
}




// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/assets/styles/styles.scss